import React from "react";

export default function SportHeader(props) {
    return (
        <div className="c_44">
            <div className={"c_44_1 " + props.icon}></div>
            <div className="c_44_2">{props.desc}</div>
        </div>
    );
}
